const customer = process.env.REACT_APP_CUSTOMER;
if (!customer) {
  throw new Error('Environmental variable REACT_APP_CUSTOMER is not set');
}

if (customer === 'ashford') import(`../customer/sass/ashford.scss`);
if (customer === 'broxbourne') import(`../customer/sass/broxbourne.scss`);
if (customer === 'cardiff') import(`../customer/sass/cardiff.scss`);
if (customer === 'darlington') import(`../customer/sass/darlington.scss`);
if (customer === 'demo') import(`../customer/sass/demo.scss`);
if (customer === 'hfh') import(`../customer/sass/hfh.scss`);
if (customer === 'hull') import(`../customer/sass/hull.scss`);
if (customer === 'kirklees') import(`../customer/sass/kirklees.scss`);
if (customer === 'leicester') import(`../customer/sass/leicester.scss`);
if (customer === 'northgate') import(`../customer/sass/northgate.scss`);
if (customer === 'preston') import(`../customer/sass/preston.scss`);
if (customer === 'rushcliffe') import(`../customer/sass/rushcliffe.scss`);
if (customer === 'selby') import(`../customer/sass/selby.scss`);
if (customer === 'sholland') import(`../customer/sass/sholland.scss`);
if (customer === 'slough') import(`../customer/sass/slough.scss`);
if (customer === 'telford') import(`../customer/sass/telford.scss`);

export const customerConfig = require(`../customer/config/${customer}`).default;
export const taxonomy = require(`@lookinglocal/scanstation-config/dist/customer/${customer}/taxonomy.json`);
export const customerLogo = require(`../customer/logo/${customer}.svg`).default;

const homePage = require(`../customer/pages/${customer}/Home`);
const aboutPage = require(`../customer/pages/${customer}/About`);
const guidancePage = require(`../customer/pages/${customer}/Guidance`);
const termsPage = require(`../customer/pages/${customer}/Terms`);
const privacyPage = require(`../customer/pages/${customer}/Privacy`);
const cookiePage = require(`../customer/pages/${customer}/Cookie`);
const contactsPage = require(`../customer/pages/${customer}/Contacts`);
const accessibilityPage = require(`../customer/pages/${customer}/Accessibility`);
const verificationDetailsPage = require(`../customer/pages/${customer}/VerificationDetails`);

export const Pages = {
  Home: homePage.default,
  About: aboutPage.default,
  Guidance: guidancePage.default,
  Terms: termsPage.default,
  Privacy: privacyPage.default,
  Cookie: cookiePage.default,
  Contacts: contactsPage.default,
  Accessibility: accessibilityPage.default,
  VerificationDetails: verificationDetailsPage.default
};
